// extracted by mini-css-extract-plugin
module.exports = {"createFeedBtnContainer":"CreateFeed_createFeedBtnContainer__ppHt4","emojiBox":"CreateFeed_emojiBox__ZTTwX"};